const cardItems = [
  {
    id: 1,
    title: '某选秀冠军私生活混乱被前女友长文实锤，聊天记录全曝光',
    excerpt: '万字长文控诉，多张私密聊天截图流出，细节令人震惊，当事人暂未回应。',
    tag: '情感爆料',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20with%20smartphone%20displaying%20private%20messages%2C%20warm%20amber%20glow%2C%20mysterious%20atmosphere%2C%20privacy%20breach%20concept%2C%20modern%20minimalist%20composition%2C%20tense%20dramatic%20lighting&width=400&height=260&seq=card-01&orientation=landscape',
    heat: '920万',
    time: '3小时前',
  },
  {
    id: 2,
    title: '知名品牌代言人翻车，品牌方连夜解约，损失或达上亿',
    excerpt: '代言人负面事件持续发酵，多个品牌紧急删除相关宣传物料，行业震动。',
    tag: '商业爆料',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20brand%20billboard%20being%20removed%20in%20darkness%2C%20dramatic%20night%20scene%2C%20warm%20orange%20street%20lights%2C%20mysterious%20urban%20atmosphere%2C%20editorial%20photography%20style%2C%20high%20contrast&width=400&height=260&seq=card-02&orientation=landscape',
    heat: '880万',
    time: '5小时前',
  },
  {
    id: 3,
    title: '某知名编剧被扒抄袭多部作品，网友整理对比图堪称实锤',
    excerpt: '热心网友逐帧对比，发现多处雷同情节和台词，业内编剧集体发声谴责。',
    tag: '文艺爆料',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20comparison%20of%20two%20documents%20side%20by%20side%20with%20red%20markings%2C%20dark%20background%2C%20warm%20highlight%20accents%2C%20investigative%20mood%2C%20modern%20editorial%20style%2C%20clean%20composition&width=400&height=260&seq=card-03&orientation=landscape',
    heat: '760万',
    time: '8小时前',
  },
  {
    id: 4,
    title: '体育圈大地震：某冠军教练被曝收受巨额贿赂操控比赛结果',
    excerpt: '知情人士提供内部文件，涉及多场重要赛事，体育总局已介入调查。',
    tag: '体育爆料',
    image: 'https://readdy.ai/api/search-image?query=Dark%20sports%20arena%20with%20dramatic%20lighting%2C%20empty%20stadium%20atmosphere%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20mysterious%20and%20tense%20mood%2C%20editorial%20photography&width=400&height=260&seq=card-04&orientation=landscape',
    heat: '710万',
    time: '12小时前',
  },
  {
    id: 5,
    title: '直播界又出大瓜：两位千万粉主播连麦互撕，直播间被封',
    excerpt: '两位头部主播因商务纠纷公开对峙，互爆对方黑料，超百万人围观。',
    tag: '直播爆料',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20dramatic%20confrontation%20scene%2C%20dark%20digital%20aesthetic%20with%20warm%20crimson%20glow%2C%20livestream%20conflict%20visualization%2C%20modern%20tech%20style%2C%20tense%20atmosphere&width=400&height=260&seq=card-05&orientation=landscape',
    heat: '680万',
    time: '1天前',
  },
  {
    id: 6,
    title: '某平台高管内部邮件泄露：裁员30%，员工吐槽区炸了',
    excerpt: '内部邮件截图疯传，涉及多个业务线大规模调整，在职员工匿名爆料。',
    tag: '职场爆料',
    image: 'https://readdy.ai/api/search-image?query=Dark%20office%20with%20glowing%20computer%20screen%20showing%20urgent%20message%2C%20warm%20amber%20light%2C%20tense%20corporate%20atmosphere%2C%20modern%20minimalist%20composition%2C%20editorial%20style&width=400&height=260&seq=card-06&orientation=landscape',
    heat: '640万',
    time: '1天前',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门黑料精选
          </h2>
          <p className="text-sm text-foreground-500 mt-2">一手吃瓜资讯，全网最新最全的爆料内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 transition-all duration-300 hover:border-accent-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-secondary-100 text-secondary-800 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-[11px] text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.time}
                  </span>
                  <span className="text-[11px] text-accent-500 flex items-center gap-1 ml-auto">
                    <i className="ri-fire-line"></i>
                    {item.heat}
                  </span>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-950 group-hover:text-accent-600 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {item.excerpt}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}